// EBIOS gravity scale (G1-G5) - single source of truth for labels and descriptions
export const GRAVITY_LEVELS = [
  {
    level: 1,
    code: 'G1',
    label: 'Mineure',
    color: 'green',
    weight: 1,
    description: 'Aucun impact opérationnel ni sur les performances de l\'activité ni sur la sécurité des personnes et des biens. La société surmontera la situation sans trop de difficultés (consommation des marges).'
  },
  {
    level: 2,
    code: 'G2',
    label: 'Modérée',
    color: 'yellow',
    weight: 2,
    description: 'Dégradation des performances de l\'activité sans impact sur la sécurité des personnes et des biens. La société surmontera la situation malgré quelques difficultés (fonctionnement en mode dégradé).'
  },
  {
    level: 3,
    code: 'G3',
    label: 'Majeure',
    color: 'orange',
    weight: 3,
    description: 'Forte dégradation des performances de l\'activité, avec d\'éventuels impacts significatifs sur la sécurité des personnes et des biens. La société surmontera la situation avec de sérieuses difficultés (fonctionnement en mode très dégradé).'
  },
  {
    level: 4,
    code: 'G4',
    label: 'Critique',
    color: 'red',
    weight: 4,
    description: 'Incapacité pour la société d\'assurer tout ou partie de son activité, avec d\'éventuels impacts graves sur la sécurité des personnes et des biens. La société ne surmontera vraisemblablement pas la situation (sa survie est menacée).'
  },
  {
    level: 5,
    code: 'G5',
    label: 'Catastrophique',
    color: 'black',
    weight: 5,
    description: 'Effondrement complet et durable de l\'activité, avec atteinte irrémédiable à la sécurité des personnes (blessures graves, décès) et aux biens (destruction totale). La survie de l\'organisation est compromise à très court terme.'
  }
];

export const getGravityByLevel = (level) =>
  GRAVITY_LEVELS.find((g) => g.level === Number(level));

export const getGravityByLabel = (label) => {
  if (label == null) return null;
  const norm = String(label).trim();
  return (
    GRAVITY_LEVELS.find((g) => g.label === norm) ||
    GRAVITY_LEVELS.find((g) => g.code === norm) ||
    GRAVITY_LEVELS.find((g, i) => ['Mineure', 'Modérée', 'Majeure', 'Critique', 'Catastrophique'][i] === norm) ||
    null
  );
};

export const getGravityColor = (level) => getGravityByLevel(level)?.color || 'green';